// 호환성을 위한 래퍼 파일
// 실제 구현은 generateSalaryContractPdf.js와 generateLaborContractPdf.js에 분리되어 있습니다.

import { generateLaborContractPdf } from './generateLaborContractPdf'
import { generateSalaryContractPdf } from './generateSalaryContractPdf'

/**
 * 계약서 타입에 따라 다른 템플릿으로 PDF 생성
 * @param {Object} data - 계약서 데이터
 * @param {'salary' | 'labor'} templateType - 템플릿 타입
 * @returns {Promise<Blob>}
 */
export const generateContractPdf = async (data, templateType = 'salary') => {
  if (templateType === 'labor') {
    return generateLaborContractPdf(data)
  }
  return generateSalaryContractPdf(data)
}

// 기존 연봉 계약서 함수와의 호환성을 위해 래퍼 제공
export { generateSalaryContractPdf } from './generateSalaryContractPdf'

// 근로 계약서 전용 함수
export { generateLaborContractPdf } from './generateLaborContractPdf'
